import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import dynamic from 'next/dynamic';
import { parseAsBoolean, useQueryState } from 'nuqs';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate/';
const FreeFormNoteEntryDialog = dynamic(() => import('../free-form-dialog'));
const AddFreeFormNote = () => {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "auditTrail.freeFormNote"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsBoolean.withDefault(false).withOptions({
      history: "push"
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [dialogOpen, setDialogOpen] = useQueryState("show-free-form-note-dialog", t1);
  let t2;
  if ($[2] !== setDialogOpen) {
    t2 = () => {
      setDialogOpen(true);
    };
    $[2] = setDialogOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleOpenDialog = t2;
  let t3;
  if ($[4] !== setDialogOpen) {
    t3 = () => {
      setDialogOpen(null);
    };
    $[4] = setDialogOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleCloseDialog = t3;
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp2);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleOpenDialog || $[11] !== t5) {
    t6 = <Button onClick={handleOpenDialog} size="compact" variant="secondary">{t5}</Button>;
    $[10] = handleOpenDialog;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <PermissionGate fallbackText={t4} scopeKind="manual_review" tooltipSide="bottom">{t6}</PermissionGate>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== dialogOpen || $[17] !== handleCloseDialog) {
    t8 = <Suspense fallback={null}><FreeFormNoteEntryDialog open={dialogOpen} onClose={handleCloseDialog} /></Suspense>;
    $[16] = dialogOpen;
    $[17] = handleCloseDialog;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default AddFreeFormNote;
function _temp($) {
  return $.addNoteButton.ctaNotAllowed;
}
function _temp2($_0) {
  return $_0.addNoteButton.title;
}